import { forwardRef } from 'react';
import { Box, Button, Divider } from '@mui/material';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';

const CustomListbox = forwardRef(function CustomListbox(props, ref) {
  const { children, onSelectAll, onClearAll, selectAllLabel, ...other } = props;

  return (
    <ul ref={ref} {...other}>
      {(onSelectAll || onClearAll) && (
        <>
          <Box px={2} py={1} display="flex" gap={2}>
            {onSelectAll && (
              <Button
                size="small"
                color="primary"
                sx={{ textTransform: 'none' }}
                startIcon={<TaskAltOutlinedIcon />}
                onMouseDown={(e) => e.preventDefault()}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelectAll();
                }}
              >
                {selectAllLabel ?? 'Select All'}
              </Button>
            )}

            {onClearAll && (
              <Button
                size="small"
                color="inherit"
                sx={{ textTransform: 'none' }}
                startIcon={<DisabledByDefaultOutlinedIcon />}
                onMouseDown={(e) => e.preventDefault()}
                onClick={(e) => {
                  e.stopPropagation();
                  onClearAll();
                }}
              >
                Clear All
              </Button>
            )}
          </Box>

          <Divider />
        </>
      )}

      {children}
    </ul>
  );
});

export default CustomListbox;
